export enum EnvironmentEnum {
    Beta = 1,
    Production = 2
}